import { AxiosPromise } from 'axios';
import { IEditSitePageFormValues } from './types';
import { instance } from '../../../../services';

const updateSite = (data: IEditSitePageFormValues): AxiosPromise => {
  const { pin } = data;

  return instance.put(`/api/sites/${pin}`, data);
};

export default updateSite;
